import {createContext, useState} from 'react'

const styles = {
  searchInput: {
    border: 'none',
    backgroundColor: 'transparent'
  }
}
export const SectionSearchBarContext = createContext({
  search: '',
  setPlaceholder: () => {}
})

export const SearchBarProvider = props => {
  const [search, setSearch] = useState('')
  const [placeholder, setPlaceholder] = useState('Search')

  return (
    <SectionSearchBarContext.Provider value={{search, setPlaceholder}}>
      <div className={`vw-dashboard__main__header__search vw-tab-search`}>
        <button className="btn-none" id="vw-tab-siteSearchBtn">
          <i className="fal fa-search"></i>
        </button>
        <input
          style={styles.searchInput}
          type="text"
          placeholder={placeholder}
          onChange={e => setSearch(e.target.value)}
        />
      </div>
      {props.children}
    </SectionSearchBarContext.Provider>
  )
}
